/*
|-------------------------------------------------------------------------------
| curp手填
|-------------------------------------------------------------------------------
*/
import { defineStore } from '~/utils/store'
import type { IStoreState } from '~/utils/store'

const CurpStore = defineStore({
  state: () => ({
    page: '', // 后端返回的页面标识
    step: 0, // 步骤条总数
    current: 0, // 当前步骤
    showProgress: false, // 是否展示步骤条
    treatmentGroup: false, // 是否命中进度条测试实验
    // 用户所填字段信息
    fields: {
      idNo: '', // curp号
      firstName: '', // 本人姓名
      middleName: '', // 父姓
      lastName: '', // 母姓
      birthday: '', // 生日
      gender: 0, // 性别
      rfc: '', // 税号
      rfcLastThree: '', // 税号后三位
      birthPlace: '', // 出生州
      curpTopTen: '', // curp隐藏场景下使用 curp前10位
    },
  }),
  mutations: {
    updatePage(state, data) {
      state.page = data
    },
    updateStep(state, data) {
      state.step = data
    },
    updateCurrent(state, data) {
      state.current = data
    },
    updateShowProgress(state, data) {
      state.showProgress = data
    },
    updateTreatmentGroup(state, data) {
      state.treatmentGroup = data
    },
    updateFields(state, data) {
      Object.assign(state.fields, data)
    },
    update(state, data) {
      Object.assign(state, data)
    },
  },
})

export default CurpStore
export type ICurpStoreState = IStoreState<
  typeof CurpStore.state
>
